export { default, defaultLanguage, isLanguageSupported, supportedLanguages } from './i18n'
